import React from 'react';
import { Helmet } from 'react-helmet';
import { companyInfo } from '../mockData';

const LocalBusinessSchema = ({ 
  pageType = 'organization', 
  serviceArea = null,
  specificServices = null 
}) => {
  
  const baseSchema = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "LegalService", "ProfessionalService"],
    "name": companyInfo.name,
    "alternateName": ["Legal Document Specialist California", "Attorney Service California"],
    "description": "Premier attorney service and legal document specialist in California. High-volume process serving, court filing, skip tracing, and document retrieval for law firms and legal professionals.",
    "url": typeof window !== 'undefined' ? window.location.origin : "https://legaldocspecialist.com",
    "telephone": companyInfo.phone,
    "email": companyInfo.email,
    "foundingDate": "2003",
    "slogan": "Highly effective professionals trained and equipped to manage high-volume legal document services",
    
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.address,
      "addressLocality": companyInfo.city,
      "addressRegion": companyInfo.state,
      "postalCode": companyInfo.zip,
      "addressCountry": "US"
    },
    
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "33.8303",
      "longitude": "-116.5453"
    },
    
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"
      ],
      "opens": "09:00",
      "closes": "17:00"
    },
    
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": companyInfo.phone,
        "contactType": "customer service",
        "areaServed": "US-CA",
        "availableLanguage": "English"
      },
      {
        "@type": "ContactPoint",
        "telephone": companyInfo.phone,
        "contactType": "attorney services",
        "areaServed": "US-CA",
        "availableLanguage": "English"
      }
    ],
    
    "areaServed": [
      {
        "@type": "State",
        "name": "California",
        "@id": "https://en.wikipedia.org/wiki/California"
      }
    ],
    
    "serviceType": [
      "Process Serving",
      "Attorney Services", 
      "Court Filing",
      "E-Filing Services",
      "Document Retrieval",
      "Skip Tracing",
      "County Recording",
      "Legal Document Services"
    ],
    
    "makesOffer": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Attorney Service Platform",
          "description": "Comprehensive litigation support platform for law firms"
        },
        "areaServed": "California"
      },
      {
        "@type": "Offer", 
        "itemOffered": {
          "@type": "Service",
          "name": "Process Serving",
          "description": "Professional process serving throughout California"
        },
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service", 
          "name": "Court Filing Services",
          "description": "E-filing and traditional court filing services"
        },
      }
    ],
    
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional License",
        "recognizedBy": {
          "@type": "Organization",
          "name": "California Secretary of State"
        }
      }
    ],
    
    "memberOf": [
      {
        "@type": "Organization",
        "name": "California Association of Legal Support Professionals",
        "url": "https://calpros.org"
      },
      {
        "@type": "Organization", 
        "name": "National Association of Professional Process Servers",
        "url": "https://napps.org"
      }
    ],
    
    "sameAs": [
      `${typeof window !== 'undefined' ? window.location.origin : "https://legaldocspecialist.com"}/attorney-service`,
      `${typeof window !== 'undefined' ? window.location.origin : "https://legaldocspecialist.com"}/process-serving`,
      "https://legaldocspecialist.legalconnect.com"
    ],
    
    "currenciesAccepted": "USD",
    "paymentAccepted": "Cash, Check, Credit Card, Invoice",
    
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  // Add specific service area for city pages
  if (serviceArea) {
    baseSchema.areaServed.push({
      "@type": "City",
      "name": serviceArea,
      "containedInPlace": "California"
    });
  }

  // Add specific services for service pages  
  if (specificServices) {
    baseSchema.additionalType = specificServices.map(service => `https://schema.org/${service}`);
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(baseSchema, null, 2)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;